import { PartnerExcelCategoryColumn } from './parsePartnerExcelDynamicColumns';
import { normalizeExcelCellValue } from './normalizeExcelHeader';

export const getPartnerCategoriesFromExcelRow = (
  excelRow: Record<string, unknown>,
  categoryColumns: PartnerExcelCategoryColumn[] = []
): string[] => {
  const categories = new Set<string>();

  categoryColumns.forEach(({ columnKey, categoryId }) => {
    const cellValue = normalizeExcelCellValue(excelRow[columnKey]);

    if (cellValue === 'SI') {
      categories.add(categoryId);
    }
  });

  return [...categories];
};
